import { LocalStorageKey } from '@constants/localStorage';

export const JWT = {
  get: () => localStorage.getItem(LocalStorageKey.JWT),
  remove: () => localStorage.removeItem(LocalStorageKey.JWT),
  set: (jwt: string = '') => localStorage.setItem(LocalStorageKey.JWT, jwt),
};
